module.exports = __webpack_public_path__ + "static/media/tunggakan.735ab4c1.png";